import React from 'react';
import { i18n } from '../../services/i18n';

export const Field = ({ label, children, className = '' }) => (
  <label className={`block ${className}`}>
    <span className="block text-[11px] font-semibold uppercase tracking-wide text-slate-500 mb-1">{label}</span>
    {children}
  </label>
);

const cls = 'w-full h-11 rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-slate-50';

export const Select = ({ value, onChange, options, placeholder, testId, format }) => (
  <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={cls}>
    <option value="">{placeholder ?? i18n.t('tw.allM')}</option>
    {options.map(o => { const [v, l] = Array.isArray(o) ? o : [o, format ? format(o) : o]; return <option key={v} value={v}>{l}</option>; })}
  </select>
);

export const NumberInput = ({ value, onChange, placeholder, testId, step = '1', min = '0' }) => (
  <input type="number" inputMode="decimal" step={step} min={min} value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} className={cls} />
);

export const TextInput = ({ value, onChange, placeholder, testId }) => (
  <input type="text" value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} className={cls} />
);

export const Toggle = ({ checked, onChange, label, hint, testId }) => (
  <label className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer select-none transition-colors ${checked ? 'border-orange-500 bg-orange-50 text-orange-800' : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'}`} title={hint}>
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId} className="rounded border-slate-300 text-orange-500" /> {label}
  </label>
);

export const Chips = ({ value, onChange, options, testIdPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map(([v, l, Icon]) => (
      <button key={v} type="button" onClick={() => onChange(value === v ? '' : v)} data-testid={`${testIdPrefix}-${v}`} aria-pressed={value === v}
        className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${value === v ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700 border-slate-300 hover:border-slate-500'}`}>
        {Icon && <Icon size={14} />} {l}
      </button>
    ))}
  </div>
);
